<div class="container">
  <h2>List of Product Attributes</h2>

  <div *ngIf="productGroups.length > 0; else noProducts" class="card-container">
    <ng-container *ngFor="let group of productGroups">
      <div class="card">
        <h3>
          <a [routerLink]="['/product', group.product.slug]">{{ group.product.title }}</a>
        </h3>
        <img *ngIf="group.filteredAttributes.length > 0 && group.filteredAttributes[0].imageUrl"
             [src]="group.filteredAttributes[0].imageUrl"
             alt="Image du produit"
             class="product-image" />

        <div class="card-body">
          <h4>Attributes:</h4>

          <!-- Filtres Individuels -->
          <div class="filters">
            <!-- Filtre Couleur -->
            <div class="filter-group">
              <label for="colorFilter-{{ group.product.id }}">Filter by Service:</label>
              <select id="colorFilter-{{ group.product.id }}"
                      [(ngModel)]="group.selectedColorId"
                      (ngModelChange)="applyFilters(group)">
                <option [ngValue]="null">All Services</option>
                <option *ngFor="let color of getAvailableColors(group)"
                        [ngValue]="color.id">
                  {{ color.title }}
                </option>
              </select>
            </div>

            <!-- Filtre Taille -->
            <div class="filter-group">
              <label for="sizeFilter-{{ group.product.id }}">Filter by Example:</label>
              <select id="sizeFilter-{{ group.product.id }}"
                      [(ngModel)]="group.selectedSizeId"
                      (ngModelChange)="applyFilters(group)"
                      [disabled]="getAvailableSizes(group).length === 0">
                <option [ngValue]="null">All Example</option>
                <option *ngFor="let size of getAvailableSizes(group)"
                        [ngValue]="size.id">
                  {{ size.title }}
                </option>
              </select>
            </div>

            <!-- Filtre Longueur -->
            <div class="filter-group">
              <label for="lengthFilter-{{ group.product.id }}">Filter by Realization:</label>
              <select id="lengthFilter-{{ group.product.id }}"
                      [(ngModel)]="group.selectedLengthId"
                      (ngModelChange)="applyFilters(group)"
                      [disabled]="getAvailableLengths(group).length === 0">
                <option [ngValue]="null">All Realizations</option>
                <option *ngFor="let length of getAvailableLengths(group)"
                        [ngValue]="length.id">
                  {{ length.title }}
                </option>
              </select>
            </div>
          </div>

          <!-- Affichage des Attributs Filtrés -->
          <div *ngIf="group.filteredAttributes.length > 0; else noFilteredAttributes">
            <h5>Attributs Filtrés:</h5>
            <ul>
              <li *ngFor="let attr of group.filteredAttributes">
                <ng-container *ngIf="!attr.product.isFeatured && !attr.product.status; else priceAlert">
                  {{ attr.price | currency }}
                  <button (click)="addToCart(attr, 1)">Add to Cart</button>
                </ng-container>
                <ng-template #priceAlert>
                  Price will be notified later.
                  <button (click)="addToCart(attr, 1)">Add to Cart</button>
                </ng-template>

              </li>
            </ul>
          </div>
          <ng-template #noFilteredAttributes>
            <p>No attributes match the selected filters.</p>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #noProducts>
    <p>No products available.</p>
  </ng-template>
</div>

